module.exports = __webpack_public_path__ + "img/bsp_jd.edc2da69.png";